// services/LevelService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// LIST (paginated)
export function getLevels(params = {}) {
    return api.get(ENDPOINTS.LEVELS.BASE, { params });
}

// GET ONE
export function getLevelById(id) {
    return api.get(ENDPOINTS.LEVELS.BY_ID(id));
}

// CREATE
export function createLevel(payload) {
    return api.post(ENDPOINTS.LEVELS.BASE, payload);
}

// UPDATE
export function updateLevel(id, payload) {
    return api.patch(ENDPOINTS.LEVELS.BY_ID(id), payload);
}

// DELETE (soft delete)
export function deleteLevel(id) {
    return api.delete(ENDPOINTS.LEVELS.BY_ID(id));
}

// RESTORE
export function restoreLevel(id) {
    return api.post(`${ENDPOINTS.LEVELS.BY_ID(id)}/restore`);
}
